module.exports = [
  'African Spirituality',
  'Agnostic',
  'Atheist',
  'Bahai',
  'Baptist',
  'Buddhist',
  'Catholic',
  'Christian',
  'Eastern Orthodox',
  'Episcopal / Anglican',
  'Hindu',
  'Humanism',
  'Interfaith',
  'Islam',
  'Jain',
  "Jehovah's Witnesses",
  'Jewish',
  'Latter-day Saints/Mormon',
  'Lutheran',
  'Methodist',
  'Multi-Faith',
  'Pagan',
  'Pentecostal',
  'Presbyterian',
  'Seventh-day Adventist',
  'Shinto',
  'Sikh',
  'Taoist',
  'Zoroastrianism',
];
